// extracted by mini-css-extract-plugin
export default {"lista_contactos":"ListaContactos_lista_contactos__EnLdW"};